import { Component, effect, inject, signal } from '@angular/core';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerDayStateService, PlannerViewsStateService } from '../../services';
import { TranslationService } from 'src/app/services/translation.service';
import dayjs from 'dayjs';

@Component({
  selector: 'app-route-day',
  standalone: true,
  imports: [
  ],
  templateUrl: './route-day.component.html',
  styleUrls: ['./route-day.component.scss'],
})
export class RouteDayComponent {
  private _translationService = inject(TranslationService);
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _plannerViewStateService = inject(PlannerViewsStateService);
  
  private _dayToShowIndex =  this._plannerDayStateService.dayToShowIndex;
  private  _isEditRouteView = this._plannerViewStateService.isEditRouteView;
  
  public selectedLanguage = this._translationService.selectedLanguage;
  
  public currentDay = signal<string>('');
    
  setCurrentDay = effect(() => {
    const dayToShowIndex = this._dayToShowIndex(); 
    this.currentDay.set(this.getCurrentDayRoute(dayToShowIndex));
  }, { allowSignalWrites: true });
  
  public getCurrentDayRoute = (dayToShowIndex: number) => !this._isEditRouteView()
    ? dayjs(this._customRouteService.customRouteData().dailyRoutes[dayToShowIndex].date).locale(this.selectedLanguage()).format('ddd D MMM')
    : dayjs(this._customRouteService.customRouteData().dailyRoutes[0].date).locale(this.selectedLanguage()).format('ddd D MMM');
}

